import { useEffect, useRef } from "react";
export function useSaveDialogLifecycle({ saveMode, setSaveMode, addLoading, addError, editLoading, editError, closeDialog, }) {
    const saveHasStartedRef = useRef(false);
    const resetSaveStartTracking = () => {
        saveHasStartedRef.current = false;
    };
    useEffect(() => {
        if (!saveMode)
            return;
        if (saveMode === "add") {
            if (addLoading) {
                saveHasStartedRef.current = true;
                return;
            }
            // Only close after we know the request actually started.
            if (!saveHasStartedRef.current)
                return;
            if (addError) {
                // Thunk already shows a toast error; keep modal open for corrections.
                setSaveMode(null);
                return;
            }
            closeDialog();
            setSaveMode(null);
            return;
        }
        if (saveMode === "edit") {
            if (editLoading) {
                saveHasStartedRef.current = true;
                return;
            }
            if (!saveHasStartedRef.current)
                return;
            if (editError) {
                setSaveMode(null);
                return;
            }
            closeDialog();
            setSaveMode(null);
        }
    }, [
        addError,
        addLoading,
        closeDialog,
        editError,
        editLoading,
        saveMode,
        setSaveMode,
    ]);
    return { resetSaveStartTracking };
}
